import { render, staticRenderFns } from "./PopUpTable.vue?vue&type=template&id=0dbf8548"
import script from "./PopUpTable.vue?vue&type=script&lang=js"
export * from "./PopUpTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports